import { animate, style, transition, trigger } from '@angular/animations';

export const animationAppearDisappear = (enterMs = 150, leaveMs = 150) =>
  trigger('appearDisappear', [
    transition(':enter', [
      style({
        opacity: 0,
      }),
      animate(
        `${enterMs}ms ease-out`,
        style({
          opacity: '*',
        }),
      ),
    ]),
    transition(':leave', [
      style({
        opacity: '*',
      }),
      animate(
        `${leaveMs}ms ease-out`,
        style({
          opacity: 0,
        }),
      ),
    ]),
  ]);

export const animationAppearDisappearWithHeight = (enterMs = 150, leaveMs = 150) =>
  trigger('appearDisappearWithHeight', [
    transition(':enter', [
      style({
        opacity: 0,
        height: 0,
      }),
      animate(
        `${enterMs}ms ease-out`,
        style({
          opacity: '*',
          height: '*',
        }),
      ),
    ]),
    transition(':leave', [
      style({
        opacity: '*',
        height: '*',
      }),
      animate(
        `${leaveMs}ms ease-out`,
        style({
          opacity: 0,
          height: 0,
        }),
      ),
    ]),
  ]);
